import { IDirective } from 'angular'

import ngRedux from 'ng-redux'
import { $timeout } from '../../../ng-compat/imports'
import {
  hideAttachCustomerTooltip,
  selectCurrentSale,
} from '../../../state/slices/currentSale/currentSaleSlice'
export const AttachCustomerTooltip = () => {
  return {
    restrict: 'A',
    controllerAs: '$ctrl',
    bindToController: true,
    controller(
      $element,
      vdTooltip,
      trainingModeManager,
      registerManager,
      saleManager,
      vdWindowDelegate,
      $ngRedux: ngRedux.INgRedux
    ) {
      'ngInject'
      const { viewport } = vdWindowDelegate.currentViewport
      const direction = viewport.match(/large/g) ? 'left' : 'center' // Matches `large` and `xlarge`

      const currentSale = selectCurrentSale($ngRedux.getState())
      if (!currentSale.hideAttachCustomerTooltip) {
        $ngRedux.dispatch(hideAttachCustomerTooltip(true))
        saleManager.saveSale()

        if (
          registerManager.isAddCustomerEnabled() &&
          !trainingModeManager.trainingModeEnabled
        ) {
          $timeout(() => {
            vdTooltip.open({
              trigger: $element,
              template: `
                <vd-tooltip class="wr-tooltip">
                  <div class="vd-text-label vd-pb1">
                    <vd-icon icon="fa-info-circle" class="vd-mr2"></vd-icon>Add a customer to this sale.
                  </div>
                  <p vd-no-widow>You haven't added a customer to this sale yet. You can search for an existing customer, add a new one, or just continue to pay.</p>
                  <div class="vd-dialog-actions">
                    <button class="vd-btn vd-btn--go vd-mt1" ng-click="$ctrl.close()">Got It</button>
                  </div>
                </vd-tooltip>
              `,
              direction,
            })
          }, 350)
        }
      }
    },
  } as IDirective
}
